import axios from "lib/axios";

export const getInfo = () => {
  return axios.get(`/info`);
};
